// for fields needing delimiter
loadDelimiterUsingId = (ids) => {
  if (!Array.isArray(ids)) ids = [ids];

  ids.forEach((id) => {
    const field = document.getElementById(id);
    if (field) applyDelimiterFormatting(field);
  });
};

loadDelimiterUsingAttr = (attrs) => {
  if (!Array.isArray(attrs)) attrs = [attrs];

  attrs.forEach((attr) => {
    const fields = document.querySelectorAll(`input[${attr}]`);
    fields.forEach((field) => applyDelimiterFormatting(field));
  });
};

function formatWithDelimiter(value) {
  let numericValue = value.replace(/[^\d.]/g, "");

  const parts = numericValue.split(".");
  if (parts.length > 2) {
    numericValue = parts[0] + "." + parts.slice(1).join("");
  }

  // add delimiter only to the integer part
  if (numericValue.includes(".")) {
    const [integerPart, decimalPart] = numericValue.split(".");
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + decimalPart;
  }

  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

function calculateCursorPosition(oldValue, oldCursorPosition, formattedValue) {
  const charsBeforeCursor = oldValue.substring(0, oldCursorPosition).replace(/,/g, "").length;

  let charCount = 0;
  for (let i = 0; i < formattedValue.length; i++) {
    if (formattedValue[i] !== ",") charCount++;
    if (charCount === charsBeforeCursor) return i + 1;
  }

  return formattedValue.length;
};

function applyDelimiterFormatting(field) {
  field.addEventListener("input", (e) => {
    const oldValue = e.target.value;
    const oldCursorPosition = e.target.selectionStart;

    const formattedValue = formatWithDelimiter(oldValue);
    e.target.value = formattedValue;

    const newCursorPosition = calculateCursorPosition(oldValue, oldCursorPosition, formattedValue);
    e.target.setSelectionRange(newCursorPosition, newCursorPosition);
  });
};
